import { apiWithoutAuth } from '@/shared/api/instances';

import { currencyPaths } from './paths';

import type { ExchangeRateTodayResponse } from '../types';

export const getExchangeRateToday = async (): Promise<ExchangeRateTodayResponse> => {
  const { data } = await apiWithoutAuth.get(currencyPaths.exchangeRateToday);
  return data.result;
};
